import {
  COLOR_BLACK,
  COLOR_BLUE_50,
  COLOR_BLUE_60,
  COLOR_BLUE_80,
  COLOR_BRAND_GRADIENT_END,
  COLOR_BRAND_GRADIENT_START,
  COLOR_BRAND_PRIMARY,
  COLOR_GRAY_15,
  COLOR_GRAY_30,
  COLOR_GREEN_30,
  COLOR_PURPLE_60,
  COLOR_RED_40,
  COLOR_SPARKS_GREEN_20,
  COLOR_TEAL_20,
  COLOR_WHITE,
  COLOR_YELLOW_ORANGE_40,
  GRADIENT_GAMEPAD_LIKE,
} from '@tinderapp/ui-core';

import { MUTUAL_FRIENDS_GREEN } from 'Config/palette';
import {
  FILL_TYPE_ANGULAR_GRADIENT,
  FILL_TYPE_LINEAR_GRADIENT,
  FILL_TYPE_RADIAL_GRADIENT,
  registerSvgFill,
} from 'Lib/SvgFillManager';

export * from 'Config/palette';

/**
 * Gradients and Fills
 * ===================
 *
 * Register fill patterns and export constants that can be used directly as a `fill` or `stroke`
 * prop within an SVG.
 */

export const FILL_PASSPORT_ICON = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 45,
    stops: [COLOR_BLUE_80, COLOR_BLUE_60],
  },
  'passport'
);

export const FILL_CONTROL_PROFILE_ICON = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 45,
    stops: [COLOR_RED_40, COLOR_YELLOW_ORANGE_40],
  },
  'control profile'
);

export const FILL_CONTROL_VISIBILITY_ICON = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 45,
    stops: [COLOR_BRAND_GRADIENT_END, COLOR_BRAND_GRADIENT_START],
  },
  'control visibility'
);

export const FILL_HIDE_ADS_ICON = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 45,
    stops: [COLOR_GRAY_30, COLOR_GRAY_15],
  },
  'hide ads'
);

export const FILL_MASK_CLOCKWISE = registerSvgFill(
  FILL_TYPE_ANGULAR_GRADIENT,
  {
    angle: 0,
    stops: [COLOR_BLACK, COLOR_WHITE],
    slices: 15,
  },
  'mask cw'
);

export const FILL_ITS_A_MATCH = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 110,
    stops: GRADIENT_GAMEPAD_LIKE.colors,
  },
  'its a match'
);

export const FILL_VIDEO_AVATAR_BORDER = registerSvgFill(
  FILL_TYPE_RADIAL_GRADIENT,
  {
    cy: 1,
    fy: 1,
    r: 1,
    stops: [COLOR_BLUE_50, COLOR_BRAND_PRIMARY],
  },
  'video avatar'
);

export const FILL_SELFIE_VERIFICATION_PENDING = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 257,
    stops: [COLOR_TEAL_20, COLOR_GREEN_30],
  },
  'selfie verification pending'
);

export const FILL_GRADIENT_STEP_ACTIVE = registerSvgFill(
  FILL_TYPE_RADIAL_GRADIENT,
  {
    stops: [
      {
        color: COLOR_SPARKS_GREEN_20,
        offset: 0,
      },
      {
        color: COLOR_WHITE,
        offset: 1,
        opacity: 0,
      },
    ],
  },
  'step active'
);

export const FILL_GRADIENT_STEP_INACTIVE = registerSvgFill(
  FILL_TYPE_RADIAL_GRADIENT,
  {
    stops: [
      {
        color: COLOR_WHITE,
        offset: 0,
      },
      {
        color: COLOR_WHITE,
        offset: 1,
        opacity: 0,
      },
    ],
  },
  'step inactive'
);

export const STROKE_GRADIENT_MUTUALS_ICON = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 0,
    stops: [
      {
        color: COLOR_WHITE,
        offset: 0,
      },
      {
        color: MUTUAL_FRIENDS_GREEN,
        offset: 1,
      },
    ],
  },
  'mutuals icon'
);

export const VAULT_GRADIENT_PRIMARY = registerSvgFill(
  FILL_TYPE_LINEAR_GRADIENT,
  {
    angle: 140,
    stops: [COLOR_PURPLE_60, COLOR_BLUE_50],
  },
  'vault gradient primary'
);
